import React, { useId } from "react";
import { Minus } from "lucide-react";
export interface Priority {
  id: number;
  name: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}
// Priority icon components from tempoissues
export const NoPriorityIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => <Minus className={className} {...props} />;
export const UrgentPriorityIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const clipId = useId();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M8.00001 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00001 1.33325C4.31811 1.33325 1.33334 4.31802 1.33334 7.99992C1.33334 11.6818 4.31811 14.6666 8.00001 14.6666Z"
          fill="#CA8A04"
          stroke="#CA8A04"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 5.33325V7.99992"
          stroke="#131519"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10.6667H8.00667"
          stroke="#131519"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const HighPriorityIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const clipId = useId();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M8 13.3334V6.66675"
          stroke="#F5F5F6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.3334V2.66675"
          stroke="#F5F5F6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 13.3334V10.6667"
          stroke="#F5F5F6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MediumPriorityIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const clipId = useId();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M8 13.3334V6.66675"
          stroke="#F5F5F6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.3334V2.66675"
          stroke="#606064"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 13.3334V10.6667"
          stroke="#F5F5F6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LowPriorityIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const clipId = useId();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M8 13.3334V6.66675"
          stroke="#606064"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.3334V2.66675"
          stroke="#606064"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 13.3334V10.6667"
          stroke="#F5F5F6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const defaultPriorities: Priority[] = [
  { id: 4, name: "Urgent", icon: UrgentPriorityIcon },
  { id: 3, name: "High", icon: HighPriorityIcon },
  { id: 2, name: "Medium", icon: MediumPriorityIcon },
  { id: 1, name: "Low", icon: LowPriorityIcon },
];
export const getPriorityName = (priority: number): string | undefined => {
  return defaultPriorities.find((p) => p.id === priority)?.name;
};
export const getPriorityIcon = (
  priority: number
): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
  return defaultPriorities.find((p) => p.id === priority)?.icon;
};
